import { useNavigate } from '@tanstack/react-router';
import { HeaderSearch } from './SearchBar/views/SearchBar';
import { HeaderAIAssistant } from './AIAssistant/views/AIAssistant';
import { HeaderNotifications } from './Notifications/views/Notifications';
import { HeaderProfile } from './UserProfile/views/Profile';
import { AccessSwitcher } from '@/features/Auth/components/AccessSwitcher';
import { AdvisorText } from '@/shared/components/AdvisorText';
import { Button } from '@/components/ui/button';

// 1:1 port of the PMS Figma TopHeader (components/TopHeader.tsx in the
// Portfolio Management Platform export). Structurally:
//
//   * 56px tall (h-14), bottom border-border/50, white surface inline
//     because Header.test.tsx asserts backgroundColor #ffffff as the
//     computed style. `bg-background` resolves to white in light mode,
//     so the solid white matches the Figma's `bg-background/95
//     backdrop-blur-sm` (the blur/opacity is a no-op here since the
//     header sits above the content rather than over it).
//   * Search sits far-left; the right cluster is the Open Account CTA
//     followed by the AI assistant / notifications / profile circles
//     (gap-3). The icon buttons render as clean bordered circles so they
//     read as controls instead of sinking into the white surface.
//
// The child components keep their full prop/hook wiring (notifications
// repository hook, user-store-backed profile, Soteria route navigation).
export const Header = () => {
  const navigate = useNavigate();
  return (
    <header
      data-figma-type
      className="relative z-50 flex h-14 shrink-0 items-center justify-between border-b border-border/50 bg-card px-3 sm:px-6"
    >
      <HeaderSearch />
      <div className="flex items-center gap-3">
        <AccessSwitcher />
        {/* Open Account — a persistent shortcut into the account-opening flow.
            #1671 removed it, on the reasoning that the flow's first step is
            choosing a client so the task should start from the client's row or
            page. Restored by product decision: the always-available entry is
            wanted even though it means the client is picked one step later.
            Live Model action format (h-8 px-3 rounded-md, black/white); 13px
            medium type — a notch below the tier tabs' text-sm, above text-xs. */}
        <Button
          size="sm"
          className="text-[13px] font-medium h-8 px-3 bg-black text-white hover:bg-black/90 dark:bg-white dark:text-black dark:hover:bg-white/90"
          onClick={() => navigate({ to: '/clients/open-account' })}
        >
          <AdvisorText source={'Open Account'} />
        </Button>
        <HeaderAIAssistant />
        <HeaderNotifications />
        <HeaderProfile />
      </div>
    </header>
  );
};
